<template>
    <div>
        <!--<mu-col class="section-container px-0">
			<picture>
				<source :srcset="`${url}.webp`" :alt="alt" type="image/webp"/>
				<img :src="`${url}.jpg`" :alt="alt"/>
			</picture>
			<mu-col class="text-banner text-white">
			 	<h2>{{ title }}</h2> 
			</mu-col>
		</mu-col>-->
		<mu-container fluid class="banner-container" :style="{ 'background-image': 'url('+ url+ '.jpg)' }">
			<mu-container class="text-center text-white" style="text-shadow:  2px 2px rgb(23, 23, 23, .3);"><h2>{{ title }}</h2></mu-container>
		</mu-container>
    </div>
</template>
<script>
export default {
    props: {
        url: {
            type: String,
            required: true
        },
        title: {
            type: String,
            required: true
		},
		alt: {
			type: String,
			required: false
		}
    },
    data() {
        return {
            
        }
    },
}
</script>

<style lang="scss">
	.banner-container{
		margin:0px;
		padding:0px;
		height:230px;
		display: flex;
		width:100%;
		align-items: center;
		background-size: 100% 100%;
   		background-repeat:no-repeat;
	}
	
	@media(min-width: 4000px) {
		.section-container { 
			img {
				height: 360px;
			}
		}
	}
	
</style>